<template>
  <el-dialog
    v-drag
    :visible.sync="dialogVisible"
    width="1200px"
    :title="editData.id ? '修改产品库信息' : '新增产品库信息'"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
    append-to-body
    top="5vh"
  >
    <el-form
      ref="form"
      class="form"
      :model="form"
      :rules="rules"
      label-position="top"
    >
      <div class="row">
        <el-form-item label="中文品名" prop="nameCH">
          <el-input v-model="form.nameCH" style="width: 510px"></el-input>
        </el-form-item>
        <el-form-item label="英文品名" prop="nameEN">
          <el-input v-model="form.nameEN" style="width: 510px"></el-input>
        </el-form-item>
      </div>
      <div class="row">
        <el-form-item label="用途" prop="used">
          <el-input v-model="form.used" style="width: 320px"></el-input>
        </el-form-item>
        <el-form-item label="材质" prop="material">
          <el-input v-model="form.material" style="width: 320px"></el-input>
        </el-form-item>
        <el-form-item label="单价最小值" prop="priceMin">
          <el-input-number
            v-model="form.priceMin"
            style="width: 320px"
            controls-position="right"
            :min="0.01"
            :precision="2"
            :step="1"
          >
          </el-input-number>
        </el-form-item>
      </div>
      <div class="row">
        <el-form-item label="单价最大值" prop="priceMax">
          <el-input-number
            v-model="form.priceMax"
            style="width: 320px"
            controls-position="right"
            :min="form.priceMin"
            :precision="2"
            :step="1"
          >
          </el-input-number>
        </el-form-item>
        <el-form-item label="重量最小值" prop="weightMin">
          <el-input-number
            v-model="form.weightMin"
            style="width: 320px"
            controls-position="right"
            :min="0.01"
            :precision="2"
            :step="1"
          >
          </el-input-number>
        </el-form-item>
        <el-form-item label="重量最大值" prop="weightMax">
          <el-input-number
            v-model="form.weightMax"
            style="width: 320px"
            controls-position="right"
            :min="form.weightMin"
            :precision="2"
            :step="1"
          >
          </el-input-number>
        </el-form-item>
      </div>
      <div class="row">
        <el-form-item label="箱重最小值" prop="pkgWeightMin">
          <el-input-number
            v-model="form.pkgWeightMin"
            style="width: 320px"
            controls-position="right"
            :min="0.01"
            :precision="2"
            :step="1"
          >
          </el-input-number>
        </el-form-item>
        <el-form-item label="箱重最大值" prop="pkgWeightMax">
          <el-input-number
            v-model="form.pkgWeightMax"
            style="width: 320px"
            controls-position="right"
            :min="form.pkgWeightMin"
            :precision="2"
            :step="1"
          >
          </el-input-number>
        </el-form-item>
        <el-form-item label="价重比最小值" prop="priceWeightMin">
          <el-input-number
            v-model="form.priceWeightMin"
            style="width: 320px"
            controls-position="right"
            :min="0.01"
            :precision="2"
            :step="1"
          >
          </el-input-number>
        </el-form-item>
      </div>
      <div class="row">
        <el-form-item label="价重比最大值" prop="priceWeightMax">
          <el-input-number
            v-model="form.priceWeightMax"
            style="width: 320px"
            controls-position="right"
            :min="form.priceWeightMin"
            :precision="2"
            :step="1"
          >
          </el-input-number>
        </el-form-item>
        <el-form-item label="美国税号" prop="hsCode">
          <el-input
            v-model="form.hsCode"
            disabled
            style="width: 290px"
          ></el-input>
          <i class="el-icon-search icon" @click="search" />
        </el-form-item>
        <el-form-item label="批次号" prop="batchNo">
          <el-input
            v-model="form.batchNo"
            disabled
            style="width: 320px"
          ></el-input>
        </el-form-item>
      </div>
      <div class="row">
        <el-form-item label="基础税率" prop="baseRate">
          <el-input
            v-model="form.baseRate"
            disabled
            style="width: 320px"
          ></el-input>
        </el-form-item>
        <el-form-item label="加征税率" prop="addRate">
          <el-input
            v-model="form.addRate"
            disabled
            style="width: 320px"
          ></el-input>
        </el-form-item>
        <el-form-item label="芬太尼税率" prop="addRate1">
          <el-input
            v-model="form.addRate1"
            disabled
            style="width: 320px"
          ></el-input>
        </el-form-item>
      </div>
      <div class="row">
        <el-form-item label="对等关税税率" prop="addRate2">
          <el-input
            v-model="form.addRate2"
            disabled
            style="width: 320px"
          ></el-input>
        </el-form-item>
        <el-form-item label="钢铁铝加征税率" prop="addRate3">
          <el-input
            v-model="form.addRate3"
            disabled
            style="width: 320px"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" style="width: 320px"></el-input>
        </el-form-item>
      </div>
    </el-form>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取消</div>
      <div class="ok flex_c_c" @click="ok('form')">
        确定{{ editData.id ? "修改" : "新增" }}
      </div>
      <div v-if="editData.id || type" style="margin-left: 16px;" class="ok flex_c_c" @click="save('form')">
        确定并确认
      </div>
    </span>
    <TaxDialog
      :dialogVisible="dialogVisible2"
      @ok="ok2"
      @cancel="cancel2"
    ></TaxDialog>
  </el-dialog>
</template>
<script>
import { saveTaxProduct, confirmTaxProduct } from '@/api/basic'
import { mapGetters } from 'vuex'
import TaxDialog from './TaxDialog'
export default {
  components: { TaxDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 0 // 0 产品列表进入 1预报进入
    },
    editData: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      form: {
        nameCH: '',
        nameEN: '',
        hsCode: '',
        material: '',
        used: '',
        remark: '',
        baseRate: '',
        addRate: '',
        addRate1: '',
        addRate2: '',
        addRate3: '',
        batchNo: '',
        createdName: '',
        priceMin: 0.01,
        priceMax: 1,
        weightMin: 0.01,
        weightMax: 1,
        pkgWeightMin: 0.01,
        pkgWeightMax: 1,
        priceWeightMin: 0.01,
        priceWeightMax: 1
      },
      rules: {
        hsCode: [
          { required: true, message: '请输入美国税号', trigger: 'blur' }
        ],
        nameEN: [
          { required: true, message: '请输入英文品名', trigger: 'blur' }
        ],
        nameCH: [
          { required: true, message: '请输入中文品名', trigger: 'blur' }
        ],
        priceMin: [
          { required: true, message: '请输入单价最小值', trigger: 'blur' }
        ],
        priceMax: [
          { required: true, message: '请输入单价最大值', trigger: 'blur' }
        ],
        weightMin: [
          { required: true, message: '请输入重量最小值', trigger: 'blur' }
        ],
        weightMax: [
          { required: true, message: '请输入重量最大值', trigger: 'blur' }
        ],
        pkgWeightMin: [
          { required: true, message: '请输入箱重最小值', trigger: 'blur' }
        ],
        pkgWeightMax: [
          { required: true, message: '请输入箱重最大值', trigger: 'blur' }
        ],
        priceWeightMin: [
          { required: true, message: '请输入价重比最小值', trigger: 'blur' }
        ],
        priceWeightMax: [
          { required: true, message: '请输入价重比最大值', trigger: 'blur' }
        ],
        baseRate: [
          { required: true, message: '请输入基础税率', trigger: 'blur' }
        ],
        addRate: [
          { required: true, message: '请输入加征税率', trigger: 'blur' }
        ],
        material: [{ required: true, message: '请输入材质', trigger: 'blur' }],
        used: [{ required: true, message: '请输入用途', trigger: 'blur' }]
      },
      dialogVisible2: false
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'companyInfo'])
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        if (this.editData.id) {
          this.form = {
            ...this.editData
          }
        } else {
          this.form = {
            nameCH: '',
            nameEN: '',
            hsCode: '',
            material: '',
            used: '',
            remark: '',
            baseRate: '',
            addRate: '',
            addRate1: '',
            addRate2: '',
            addRate3: '',
            batchNo: '',
            createdName: '',
            priceMin: 0.01,
            priceMax: 1,
            weightMin: 0.01,
            weightMax: 1,
            pkgWeightMin: 0.01,
            pkgWeightMax: 1,
            priceWeightMin: 0.01,
            priceWeightMax: 1
          }
        }
      }
    }
  },
  methods: {
    cancel() {
      this.$refs['form']?.resetFields()
      this.$emit('cancel')
    },
    ok(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          const params = {
            ...this.form,
            createdName: this.userInfo.userName,
            companyId: this.companyInfo?.id
          }
          try {
            const res = await saveTaxProduct(params)
            if (res.success) {
              this.$message.success('操作成功')
              this.$refs[formName]?.resetFields()
              this.$emit('ok')
            } else {
              this.$message.error(res.errorMessage)
            }
          } catch (error) {
            console.log(error)
          }
          console.log(params, saveTaxProduct)
        }
      })
    },
    save(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          const params = {
            ...this.form,
            createdName: this.userInfo.userName,
            companyId: this.companyInfo?.id
          }
          try {
            const res = await saveTaxProduct(params)
            confirmTaxProduct(params)
            if (res.success) {
              this.$message.success('操作成功')
              this.$refs[formName]?.resetFields()
              this.$emit('ok')
            } else {
              this.$message.error(res.errorMessage)
            }
          } catch (error) {
            console.log(error)
          }
          console.log(params, saveTaxProduct)
        }
      })
    },
    search() {
      this.dialogVisible2 = true
    },
    ok2(row) {
      console.log('row', row)
      this.form = {
        ...this.form,
        hsCode: row.hsCode,
        baseRate: row.baseRate,
        addRate: row.addRate,
        addRate1: row.addRate1,
        addRate2: row.addRate2,
        addRate3: row.addRate3,
        batchNo: row.batchNo
      }
      this.cancel2()
    },
    cancel2() {
      this.dialogVisible2 = false
    }
  }
}
</script>
<style lang="less" scoped>
:deep(.el-dialog__body) {
  padding: 30px 10px;
}
.form {
  margin: 0 54px;
}
.row {
  display: flex;
  justify-content: space-between;
  &:deep(.el-form-item) {
    margin-bottom: 16px;
    .el-form-item__label {
      line-height: 20px;
    }
  }
  .icon {
    font-size: 20px;
    margin-left: 10px;
    cursor: pointer;
    color: rgb(18, 88, 188);
  }
}
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background: rgb(18, 88, 188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
